import { BookingsSummaryReportDto } from './BookingsSummaryReportDto';
import { BookingsSummaryReport } from 'model/BookingsReport';

export const convertToBookingSummaryReport = (response: BookingsSummaryReportDto): BookingsSummaryReport => {
    return {
        totalBookings: response.total_bookings,
        totalClients: response.total_customers,
        totalPets: response.total_pets,
        totalServices: response.total_services,
        totalAddons: response.total_addons,
        totalProducts: response.total_products,
        totalCustomItems: response.total_custom_items,
        totalValue: response.total_value,
        averageBookingValue: response.average_booking_value
    };
};
